import { useState } from "react";
import { useChargesContext } from "../context/ChargesContext";
import {
  deleteChargeItem,
  fetchAllVersionBatches,
  publishAllCatalogVersions,
  saveChargeItem,
} from "../services/chargesService";

export const useChargeUpdater = (user) => {
  const { state, dispatch } = useChargesContext();
  const [actionError, setActionError] = useState("");

  const saveItem = async ({ catalogId, categoryId, item }) => {
    try {
      setActionError("");
      dispatch({ type: "SET_SAVING", payload: true });

      const savedItem = await saveChargeItem({
        catalogId,
        categoryId,
        item,
        user,
      });

      dispatch({
        type: "UPSERT_ITEM_LOCAL",
        payload: { catalogId, categoryId, item: savedItem },
      });

      dispatch({ type: "CLOSE_EDITOR" });
    } catch (error) {
      console.error("Failed to save item:", error);
      setActionError(error?.message || "Failed to save charge.");
    } finally {
      dispatch({ type: "SET_SAVING", payload: false });
    }
  };

  const removeItem = async ({ catalogId, categoryId, itemId }) => {
    try {
      setActionError("");
      dispatch({ type: "SET_SAVING", payload: true });

      await deleteChargeItem({ catalogId, categoryId, itemId });

      dispatch({
        type: "REMOVE_ITEM_LOCAL",
        payload: { catalogId, categoryId, itemId },
      });
    } catch (error) {
      console.error("Failed to delete item:", error);
      setActionError(error?.message || "Failed to delete charge.");
    } finally {
      dispatch({ type: "SET_SAVING", payload: false });
    }
  };

  const publishAllVersions = async ({ notesByCatalog }) => {
    try {
      setActionError("");
      dispatch({ type: "SET_SAVING", payload: true });

      await publishAllCatalogVersions({
        catalogs: state.catalogs,
        notesByCatalog,
        user,
      });

      const batches = await fetchAllVersionBatches();

      dispatch({
        type: "SET_VERSION_BATCHES",
        payload: batches,
      });
    } catch (error) {
      console.error("Failed to publish versions:", error);
      setActionError(error?.message || "Failed to publish.");
    } finally {
      dispatch({ type: "SET_SAVING", payload: false });
    }
  };

  return {
    saveItem,
    removeItem,
    publishAllVersions,
    actionError,
  };
};
